<template>
  <RevCheckbox id="sameAsShipping" v-model="isChecked">
    <template #label>
      {{ i18n(translations.sameAddress) }}
    </template>
  </RevCheckbox>
</template>

<script setup lang="ts">
import type { ApiSpecs } from '@backmarket/nuxt-module-http-v2/specs'
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { isEqual } from '@backmarket/utils/object/isEqual'
import { pick } from '@backmarket/utils/object/pick'
import { RevCheckbox } from '@ds/components/Checkbox'

import {
  isBillingAddressComplete,
  isShippingAddressComplete,
} from '~/scopes/checkout/utils/address'

import translations from './SameAsShippingCheckbox.translations'

const fieldsToCompare: Array<
  keyof NonNullable<
    | ApiSpecs['/bm/cart']['GET']['response']['addressList']['deliver']
    | ApiSpecs['/bm/cart']['GET']['response']['addressList']['bill']
  >
> = [
  'firstName',
  'lastName',
  'firstNamePronunciation',
  'lastNamePronunciation',
  'country',
  'stateOrProvince',
  'postalCode',
  'city',
  'street',
  'street2',
]

const i18n = useI18n()

const props = defineProps<{
  addressList: ApiSpecs['/bm/cart']['GET']['response']['addressList']
}>()

const isChecked = defineModel<boolean>({ default: false })

const areAddressesEqual = () => {
  if (!props.addressList.deliver || !props.addressList.bill) return false

  return isEqual(
    pick(props.addressList.deliver, fieldsToCompare),
    pick(props.addressList.bill, fieldsToCompare),
  )
}

isChecked.value =
  !isShippingAddressComplete(props.addressList.deliver) ||
  !isBillingAddressComplete(props.addressList.bill) ||
  areAddressesEqual()
</script>
